/**
 * Linien-Icons fuer HOMEBASE.
 *
 * HOMEBASE hatte bis hierher kein Iconsystem und keine Icon-Bibliothek. Statt
 * fuer drei Zeichen eine Abhaengigkeit einzufuehren, stehen sie hier als
 * eigene, ruhige Linienzeichnungen: 24er Raster, 1,5 Strich, runde Enden,
 * Farbe aus `currentColor`. Wer weitere braucht, zeichnet sie im selben Raster
 * dazu -- so bleibt die Handschrift einheitlich.
 *
 * Die Zeichen sind Schmuck neben einer Beschriftung und tragen deshalb
 * `aria-hidden`; die Beschriftung sagt, was gemeint ist.
 */
const Linie = ({ children }: { children: React.ReactNode }): React.JSX.Element => (
  <svg className="icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
    strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    {children}
  </svg>
);

/** Schiff -- Seefracht. */
export const IconSchiff = (): React.JSX.Element => (
  <Linie>
    <path d="M3 17c1.5 1.2 3 1.2 4.5 0s3-1.2 4.5 0 3 1.2 4.5 0 3-1.2 4.5 0" />
    <path d="M4.5 14.5 3.5 11h17l-1 3.5" />
    <path d="M7 11V7.5h6V11" />
    <path d="M13 9h3.5L18 11" />
    <path d="M9.5 7.5V5" />
  </Linie>
);

/** Zug -- Bahnfracht. */
export const IconZug = (): React.JSX.Element => (
  <Linie>
    <rect x="6" y="3.5" width="12" height="13" rx="3" />
    <path d="M6 10h12" />
    <circle cx="9" cy="13.2" r="0.6" />
    <circle cx="15" cy="13.2" r="0.6" />
    <path d="M9 16.5 7 20.5" />
    <path d="M15 16.5l2 4" />
    <path d="M8.2 19h7.6" />
  </Linie>
);

/** Flugzeug -- Luftfracht. */
export const IconFlugzeug = (): React.JSX.Element => (
  <Linie>
    <path d="M10.5 20.5 12 17l-.5-4.5L4 15v-1.8l7.5-4.2V4.5a1.5 1.5 0 0 1 3 0V9l7.5 4.2V15l-7.5-2.5L14 17l1.5 3.5" />
  </Linie>
);

/** Chevron -- auf- und zuklappen. Zeigt nach unten; gedreht wird per CSS. */
export const IconChevron = (): React.JSX.Element => (
  <Linie>
    <path d="m6 9 6 6 6-6" />
  </Linie>
);
